<template>
  <div>
    <v-row class="mt-n12" v-if="tableDisplay != 'offices'">
      <v-col cols="12" style="margin-top: -80px">
        <v-row>
          <v-col cols="12" class="text-right">
            <v-btn
              color="primary"
              dark
              rounded
              small
              class="mx-2"
              @click="dialog = true"
            >
              Create Office Group
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row class="mb-4 px-3 mt-n2" v-if="selected.length > 0">
          <v-app-bar color="grey darken-3" dense dark>
            <v-toolbar-title class="overline"
              >{{ selected.length }} selected</v-toolbar-title
            >
            <v-divider class="mx-4" vertical></v-divider>
            <v-btn
              depressed
              class="overline mx-4 custom-hover"
              color="grey darken-3"
              @click="updateDetails"
              >Update</v-btn
            >
            <v-btn
              depressed
              class="overline mx-4 custom-hover"
              color="grey darken-3"
              @click="deleteGroup()"
              >Delete</v-btn
            >
          </v-app-bar>
        </v-row>
      </v-col>
      <v-col cols="12" class="mt-n8" v-show="showSuccessMessage">
        <v-alert dense text type="success" dismissible
          >Created new office group</v-alert
        >
      </v-col>
      <v-col cols="12" class="mt-n8" v-show="showSuccess">
        <v-alert dense text type="success" dismissible
          >Updated office group details</v-alert
        >
      </v-col>
      <v-col>
        <v-data-table
          v-model="selected"
          :single-select="false"
          show-select
          :headers="headers"
          :items="allOfficeGroups"
          :items-per-page="10"
          class="elevation-2 mt-n6"
          item-key="id"
          :search="search"
          :loading="isFetching"
          loading-text="Loading... Please wait"
        >
          <!-- <template v-slot:[`item.actions`]="{ item }">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-arrow-down-drop-circle
                </v-icon>
              </template>
              <v-list>
                <v-list-item class="action-item">
                  <v-list-item-title class="pointer" @click="updateDetails(item)">Update Details</v-list-item-title>
                </v-list-item>
                <v-list-item class="action-item">
                  <v-list-item-title class="pointer" @click="deleteGroup(item)">Delete Group</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template> -->
        </v-data-table>
      </v-col>
      <v-snackbar v-model="snackbar" :timeout="timeout">
        "Must select only one office group to update details"
        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <AssignOffice
        :dialog="officesDialog"
        :selectedOffice="selectedGroup"
        @closeDialog="close"
      />
      <OfficeGroupCreateModal
        :dialog="dialog"
        :officeGroup="selectedGroup"
        @closeDialog="closeOfficeGroup"
      />
    </v-row>
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import OfficeGroupCreateModal from "../OfficeGroupCreateModal";
  import AssignOffice from "../AssignOffice";
  import Swal from "sweetalert2";
  import LoadingOverlay from "../common/LoadingOverlay.vue";

  export default {
    name: "OfficeGroups",
    components: {
      OfficeGroupCreateModal,
      AssignOffice,
      LoadingOverlay
    },
    props: {
      tableDisplay: String,
      search: String,
    },
    data() {
      return {
        isFetching: false,
        loading: false,
        singleSelect: false,
        selected: [],
        dialog: false,
        errorMessage: null,
        headers: [
          {
            text: "Name",
            align: "start",
            sortable: true,
            value: "name",
          },
          { text: "Description", value: "description" },
          { text: "Created", value: "date" },
        ],
        editedIndex: -1,
        editedItem: {
          name: "",
          description: "",
        },
        defaultItem: {
          name: "",
          description: "",
        },
        options: {
          page: 1,
          itemsPerPage: 5,
        },
        selectedGroup: null,
        officesDialog: false,
        showSuccess: false,
        showSuccessMessage: false,
        snackbar: false,
        timeout: 5000,
        fetchOnce: false,
      };
    },
    methods: {
      ...mapActions([
        "fetchOfficeGroups",
        "deleteOfficeGroup",
        "updateOfficeGroup",
      ]),
      editItem(item) {
        this.errorMessage = null;
        this.editedIndex = this.allOfficeGroups.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      close() {
        this.dialog = false;
        this.officesDialog = false;
        this.errorMessage = null;
        this.selectedGroup = null;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      closeOfficeGroup(value, action) {
        if(action == "Update"){
          this.showSuccess = value ? true : false;
          this.showSuccessMessage = false;
        }
        if(action == "Create"){
          this.showSuccessMessage = value ? true : false;
          this.showSuccess = false;
        }
        if(action == "Close"){
          this.showSuccessMessage = false;
          this.showSuccess = false;
        }
        this.dialog = false;
        this.officesDialog = false;
        this.errorMessage = null;
        this.selectedGroup = null;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
        this.selected = [];
      },
      async save() {
        if (this.editedIndex > -1) {
          const update = await this.updateOfficeGroup(this.editedItem);
          if (update.error) {
            if (update.status == 400) this.errorMessage = update.message;
            else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Internal Server Error",
              });
            }
          } else if (update) {
            this.showSuccess = true;
            this.showSuccessMessage = false;
            this.name = "";
            this.location = "";
            this.dialog = false;
            this.errorMessage = null;
            this.close();
          }
        }
      },
      assignOffices(item) {
        this.officesDialog = true;
        this.selectedGroup = item;
      },
      updateDetails() {
        if (this.selected.length > 1) {
          this.snackbar = true;
        } else {
          this.dialog = true;
          this.selectedGroup = this.selected[0];
        }
      },
      deleteGroup() {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        }).then((result) => {
          let selectedItem = [];
          for (let i = 0; i < this.selected.length; i++) {
            selectedItem.push(this.selected[i].id);
          }
          if (result.isConfirmed) {
            this.loading = true;
            this.deleteOfficeGroup(selectedItem).then(() => {
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
              this.selected = []
              this.loading = false;
            });
          }
        });
      },

      // readDataFromOfficeGroupStore() {
      //   const { page, itemsPerPage } = this.options;
      //   this.fetchOfficeGroups({ page, itemsPerPage });
      // },
    },
    computed: mapGetters(["allOfficeGroups", "totalOfficeGroupCount"]),
    created() {
      if(this.allOfficeGroups.length == 0 )
        this.isFetching = true
      this.fetchOfficeGroups({ itemsPerPage : 0 }).then(() => {
        this.isFetching = false
      })
    }
    // watch: {
    //   tableDisplay: function() {
    //     this.showSuccess = false;
    //     if (!this.fetchOnce) {
    //       this.fetchOfficeGroups({ itemsPerPage: 0 });
    //       this.fetchOnce = true;
    //     }
    //   },
    //   // options: {
    //   //   handler() {
    //   //     this.readDataFromOfficeGroupStore();
    //   //   },
    //   // },
    //   // deep: true,
    // },
  };
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }
</style>
